import { ControllerHand, PLAYERS_ROOM_UID } from "flavr-common";
import { usersService } from "@modules/multiplayer/UsersService";
import { UNDEFINED_CLIENT_ID } from "@modules/users";
import { modelPool } from "@modules/model/ModelPool";
/// Player part names ///
const PLAYER_ID_PREFIX = "player_";
export function getPlayerRootModelName(clientIdx) {
    return `${PLAYER_ID_PREFIX}${clientIdx}`;
}
export function getPlayerHeadModelName(clientIdx) {
    return `head_${getPlayerRootModelName(clientIdx)}`;
}
export function getPlayerControllerModelName(clientIdx, hand) {
    const playerRootName = getPlayerRootModelName(clientIdx);
    switch (hand) {
        case ControllerHand.LeftHand:
            return `controller_left_${playerRootName}`;
        case ControllerHand.RightHand:
            return `controller_right_${playerRootName}`;
        default:
            return `controller_unknown_${playerRootName}`;
    }
}
export function getPlayerMouseModelName(clientIdx) {
    return `mouse_${getPlayerRootModelName(clientIdx)}`;
}
/// Local player idx ///
export function getLocalPlayerClientIdxOrThrow() {
    const localUser = usersService.getLocalUser();
    if (localUser.clientId === UNDEFINED_CLIENT_ID || localUser.clientIdx < 0) {
        throw new Error("[localplayer] Local user is not initialized yet");
    }
    return localUser.clientIdx;
}
export function hasLocalPlayerClientIdx() {
    const localUser = usersService.getLocalUser();
    return localUser.clientId !== UNDEFINED_CLIENT_ID && localUser.clientIdx >= 0;
}
/// Player models ///
export function ensurePlayerRootModel(clientIdx) {
    var _a;
    const playersRoom = modelPool.getModelOrThrow(PLAYERS_ROOM_UID);
    const rootModelName = getPlayerRootModelName(clientIdx);
    return (_a = playersRoom.getChild(rootModelName)) !== null && _a !== void 0 ? _a : modelPool.createModel(rootModelName, playersRoom);
}
export function ensurePlayerHeadModel(clientIdx) {
    var _a;
    const playerRoot = ensurePlayerRootModel(clientIdx);
    const headModelName = getPlayerHeadModelName(clientIdx);
    return (_a = playerRoot.getChild(headModelName)) !== null && _a !== void 0 ? _a : modelPool.createModel(headModelName, playerRoot);
}
export function ensurePlayerControllersModel(clientIdx) {
    return ensurePlayerRootModel(clientIdx);
}
export function ensureLocalPlayerRootModel() {
    return ensurePlayerRootModel(getLocalPlayerClientIdxOrThrow());
}
export function ensureLocalPlayerHeadModel() {
    return ensurePlayerHeadModel(getLocalPlayerClientIdxOrThrow());
}
export function ensureLocalPlayerControllersModel() {
    return ensurePlayerControllersModel(getLocalPlayerClientIdxOrThrow());
}
